export interface PagedResult<T> {
  results: T[];
  count: number;
}
